$(document).ready(function() {


// Key Message Mobile Slider 
const sliders = document.querySelectorAll('.slider');
const currentSlides = [];

function showSlide(sliderIndex, n) {
  const slides = sliders[sliderIndex].querySelectorAll('.slide');
  slides[currentSlides[sliderIndex]].classList.remove('active');
  slides[n].classList.add('active');
  currentSlides[sliderIndex] = n;
}

function nextSlide(sliderIndex) {
  const slides = sliders[sliderIndex].querySelectorAll('.slide');
  let next = currentSlides[sliderIndex] + 1;
  if (next >= slides.length) {
    next = 0;
  }
  showSlide(sliderIndex, next);
}

function prevSlide(sliderIndex) {
  const slides = sliders[sliderIndex].querySelectorAll('.slide');
  let prev = currentSlides[sliderIndex] - 1;
  if (prev < 0) {
    prev = slides.length - 1;
  }
  showSlide(sliderIndex, prev);
}

sliders.forEach((slider, index) => {
  currentSlides[index] = 0;
  showSlide(index, currentSlides[index]);
  setInterval(() => {
    nextSlide(index);
  }, 5000);
  slider.addEventListener('touchstart', evt => {
    startX = evt.touches[0].pageX;
    startY = evt.touches[0].pageY;
  });
  slider.addEventListener('touchmove', evt => {
    if (startX && startY) {
      const deltaX = startX - evt.touches[0].pageX;
      const deltaY = startY - evt.touches[0].pageY;
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        if (deltaX > 0) {
          nextSlide(index);
        } else {
          prevSlide(index);
        }
        startX = null;
        startY = null;
      }
    }
  });
});



  // Check if the current page is a collection or search page
  const isCollectionPage = document.body.classList.contains('template-collection');
  const isSearchPage = document.body.classList.contains('template-search');

  if (isCollectionPage || isSearchPage) {
      // Get all product elements on the page
      const products = document.querySelectorAll('.grid__item');

      // Loop through each product and check if the "custom.hide_product" metafield is true
      products.forEach((product) => {
          const hideProduct = product.getAttribute('data-hide-product');
          if (hideProduct === 'true') {
              // If the "custom.hide_product" metafield is true, remove the product element from the DOM
              product.parentNode.removeChild(product);
          }
      });
  }

    // Get all HTML elements with class "b2b" or "b2c"
  var elements = document.querySelectorAll('.b2b, .b2c');

  // Loop through all elements and add inline style "display: none;"
  for (var i = 0; i < elements.length; i++) {
      elements[i].style.display = 'none';
  }

  var checkbox = document.getElementById('switch');
  checkbox.addEventListener('change', function() {
      location.reload();
  });


  var userType = getCookie('userType');
  if (userType === 'personal') {
    $('.b2b').remove(); // completely remove the elements with class 'b2b'
    $('.b2c').show();
  } else if (userType === 'business') {
    $('.b2c').remove(); // completely remove the elements with class 'b2b'
    $('.b2b').show();
    
    // Registers klaviyo b2b intent
    // Set delay on sending klaviyo event to give time to delay load the main script
    setTimeout(function() { send_klaviyo_event(); }, 3500);
    
    function send_klaviyo_event() {
      // Track events for an identified user
      klaviyo.push(['track', 'B2B Intent', {
        'Date': new Date().toLocaleDateString()
      }]);
      console.log('Triggered B2B event');
    }
  }


  
  /* 
   * Detect utm_medium params to override discount codes for specific channels (EG CPC)
   */
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  let utm_value = params.utm_medium; // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
  if (typeof utm_value !== 'undefined' && utm_value !== null && utm_value.length > 0) {
    // Store cookie with the correct discount code (so we can track channels better)
    if (utm_value == 'cpc') setCookie('discountCode','STAR15',30);
    else if (utm_value == 'linkedin') setCookie('disableAlcohol','true',30);
  }

  /*
   * Check on page load if we have a cookie with a discount code override
   */
  if (typeof getCookie('discountCode') !== 'undefined' && getCookie('discountCode') !== null & getCookie('discountCode').length > 0) {
    $('.jq-discount-override').text(getCookie('discountCode'));
  }

  /*
   * Check on page load if we have a cookie to disable alcohol messaging
   */
  if (typeof getCookie('disableAlcohol') !== 'undefined' && getCookie('disableAlcohol') !== null & getCookie('disableAlcohol').length > 0) {
    $('.jq-disable-alcohol').hide();
  }


  /* 
   * Order within countdown (Product Page)
   */
  var start_actual_time = new Date();
  var end_actual_time = new Date();
  var get_by_day = new Date();

  // Check if we have a cut off time, if not use system default
  var check_cut_off = $('.jq-order-within').data('cut-off-time');
  if (typeof check_cut_off != 'undefined')
      var cut_off = check_cut_off;
  else
      var cut_off = '13:00'; // Use system default

  cut_off = cut_off.split(':');
  var earliestDeliveryDate = 1; // On the datepicker we use this to add on the number of days before the earliest delivery date (1 = tomorrow)

  // Set delivery date (based on what day of week we're on)
  if (start_actual_time.getDay() == 0) {
      get_by_day.setDate(get_by_day.getDate() + 2); // Sunday
      earliestDeliveryDate = 2;
  } else if (start_actual_time.getDay() == 5) {
      get_by_day.setDate(get_by_day.getDate() + 3); // Friday
      earliestDeliveryDate = 3;
  } else if (start_actual_time.getDay() == 6) {
      get_by_day.setDate(get_by_day.getDate() + 2); // Saturday
      earliestDeliveryDate = 2;
  } else get_by_day.setDate(get_by_day.getDate() + 1); // Every other day (before cut off)

  // Check if we're passed the cut off time (TODO feed in the actual cut off from schema)
  if (start_actual_time.getHours() >= cut_off[0] && start_actual_time.getMinutes() >= cut_off[1]) {

      // Increment end day by one
      end_actual_time.setDate(end_actual_time.getDate() + 1);

      // Increment when we're getting item by a day
      get_by_day.setDate(get_by_day.getDate() + 1);

      // Increment whatever the datepicker's earliest delivery date is by 1
      earliestDeliveryDate = earliestDeliveryDate + 1;

  }

  // Update based on cut off defined in schema
  end_actual_time.setHours(cut_off[0], cut_off[1], 0, 0);

  /*
   * Countdown timer (Product Page)
   */
  function getTimeRemaining(endtime) {
      const total = Date.parse(endtime) - Date.parse(new Date());
      const seconds = Math.floor((total / 1000) % 60);
      const minutes = Math.floor((total / 1000 / 60) % 60);
      const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
      const days = Math.floor(total / (1000 * 60 * 60 * 24));

      return {
          days,
          hours,
          minutes,
          seconds
      };
  }

  function initializeClock(id, endtime, getby) {

      function updateClock() {
          const t = getTimeRemaining(endtime);
          const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
          var htmlDate = '';

          // Build String (so we don't just write 0 all the time)
          if (t.days > 0) {
              htmlDate = htmlDate + t.days;
              if (t.days > 1) htmlDate = htmlDate + ' days, ';
              else htmlDate = htmlDate + ' day, ';
          }

          if (t.hours > 0) {
              htmlDate = htmlDate + t.hours;
              if (t.hours > 1) htmlDate = htmlDate + ' hours, ';
              else htmlDate = htmlDate + ' hour, ';
          }

          if (t.minutes > 0) {
              htmlDate = htmlDate + t.minutes;
              if (t.minutes > 1) htmlDate = htmlDate + ' minutes and ';
              else htmlDate = htmlDate + ' minute and ';
          }

          if (t.seconds > 0) {
              htmlDate = htmlDate + t.seconds;
              if (t.seconds > 1) htmlDate = htmlDate + ' seconds ';
              else htmlDate = htmlDate + ' second ';
          }

          // Update HTML
          $('.jq-order-within').html(htmlDate);

          // Build out string of when we can get item by 
          $('.jq-get-by').html(getby.getDate() + formatDay(getby.getDate()) + ' ' + monthNames[getby.getMonth()]);

          if (t.total <= 0) {
              clearInterval(timeinterval);
          }
      }

      updateClock();
      const timeinterval = setInterval(updateClock, 1000);
  }

  function formatDay(d) {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
          case 1:
              return "st";
          case 2:
              return "nd";
          case 3:
              return "rd";
          default:
              return "th";
      }
  }
  // Now start the countdown timer
  initializeClock('jq-order-within', end_actual_time, get_by_day);


 
    
    // Countdown Timer for Annoucement Bar
    // Get the initial end date from the Liquid variable in the "dd/mm/yyyy hh:mm:ss" format
    var endDateString = "12/06/2025 13:00:00";
    var endDateParts = endDateString.split(" ");
    var dateParts = endDateParts[0].split("/");
    var timeParts = endDateParts[1].split(":");
    var countDownDate = new Date(dateParts[2], (dateParts[1] - 1), dateParts[0], timeParts[0], timeParts[1], timeParts[2]).getTime();

    // Check if the extension end date is defined and get it from the Liquid variable in the "dd/mm/yyyy hh:mm:ss" format
    var extensionCountDownDate;
    var isExtended = false;
    if ("" !== "") {
        var extensionDateString = " ";
        var extensionParts = extensionDateString.split(" ");
        var extensionDateParts = extensionParts[0].split("/");
        var extensionTimeParts = extensionParts[1].split(":");
        extensionCountDownDate = new Date(extensionDateParts[2], (extensionDateParts[1] - 1), extensionDateParts[0], extensionTimeParts[0], extensionTimeParts[1], extensionTimeParts[2]).getTime();
    }

    // Update the countdown every second
    var x = setInterval(function() {

        // Get today's date and time
        var now = new Date().getTime();

        // Determine which end date to use
        var currentCountDownDate = countDownDate;
        if (extensionCountDownDate !== undefined && now > countDownDate && now < extensionCountDownDate) {
            currentCountDownDate = extensionCountDownDate;
            isExtended = true;
        } else {
            isExtended = false;
        }

        // Calculate the distance between now and the current count down date
        var distance = currentCountDownDate - now;

        // Calculate days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Output the result in an element with id="countdown"
        var message = "";
        if (isExtended) {
            message += "EXTENDED ";
        }
        message += days + "d " + hours + "h " + minutes + "m " + seconds + "s";
        var countdownElements = document.querySelectorAll(".js-countdown");
        for (var i = 0; i < countdownElements.length; i++) {
            countdownElements[i].innerHTML = message;
        }

        // If the countdown is finished, display a message
        if (distance < 0) {
            clearInterval(x);
            for (var i = 0; i < countdownElements.length; i++) {
                countdownElements[i].innerHTML = "EXPIRED";
            }
        }
    }, 1000);
  // Brochure download form
  $('#jq-brochure-download').submit(function(event) {
    
    // Check captcha is filled in correctly
    // var captchaRes = $('.jq-captcha').val();
    // if (captchaRes == 6) {
     	$('.jq-btn-send').val('Submitting...');
	    $('.jq-btn-send').prop('disabled',true); 
    // }
    // else {
    //  	alert('Sorry - you entered an incorrect answer for the robot question'); 
    //   	return false;
    // }

  }); 
  
  // Quote request form
  $('#jq-quote-request').submit(function(event) {
    
    // Check captcha is filled in correctly
    // var captchaRes = $('.jq-captcha').val();
    // if (captchaRes == 1) {
     	$('.jq-btn-send').val('Submitting...');
	    $('.jq-btn-send').prop('disabled',true); 
    // }
    // else {
    //  	alert('Sorry - you entered an incorrect answer for the robot question'); 
    //   	return false;
    // }

  });

  /*
   * Load extra scripts here on document ready so they don't render block
   */ 
  setTimeout(function() { load_page_scripts(); }, 500); // Lower this once out of testing
 
  function load_page_scripts() {
    window.__lo_site_id = 321925; // Lucky Orange
    (function() {
        var wa = document.createElement('script'); wa.type = 'text/javascript'; wa.async = true;
        wa.src = 'https://d10lpsik1i8c69.cloudfront.net/w.js';
        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(wa, s);
    })(); // Lucky Orange
	
    $('<script/>',{type:'text/javascript', async:true, id:'ze-snippet', src:'https://static.zdassets.com/ekr/snippet.js?key=d10b050c-c373-4983-b0f5-eed824e95a61'}).appendTo('head'); // Zendesk Chat
  }

  /*
   * Temp Solution Refresh page when price finder changes
   */ 
// Store the current value of the filter parameters
var currentGte = getQueryParam('filter.v.price.gte');
var currentLte = getQueryParam('filter.v.price.lte');

// Check for changes in the filter parameters every second
setInterval(function() {
  // Get the current value of the filter parameters
  var newGte = getQueryParam('filter.v.price.gte');
  var newLte = getQueryParam('filter.v.price.lte');

  // If either parameter has changed, refresh the page
  if (newGte !== currentGte || newLte !== currentLte) {
    window.location.reload();
  }
}, 1000);

// Helper function to get the value of a URL parameter
function getQueryParam(name) {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

  const applyBtn = document.querySelector('.apply-btn');

applyBtn.addEventListener('click', () => {
  location.reload();
});

 const popout = document.querySelector('.popout-list__option');

popout.addEventListener('click', () => {
  location.reload();
});

// Function to refresh the page after a delay
function refreshPageWithDelay() {
    // Add a delay of 500 milliseconds (0.5 seconds)
    setTimeout(function() {
        // Refresh the page
        location.reload();
    }, 500);
}

// Get all elements with the class "popout-list__option"
var popoutOptions = document.querySelectorAll('.popout-list__option');

// Add click event listener to each popout-list__option element
popoutOptions.forEach(function(option) {
    option.addEventListener('click', function() {
        // Call the function to refresh the page with a delay
        refreshPageWithDelay();
    });
});

  
});

